import { round } from 'lodash'

/**
 * Arredonda o valor para o número de casas decimais desejadas e formata para texto
 * @param value valor a ser formatado
 * @param precision número de casas decimais desejadas, padrão = 2
 */
export function formatNumber(value: number | string, precision: number = 2) {
  const formatter = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: precision })
  const numberValue = typeof value === 'number' ? value : parseNumber(value)
  return formatter.format(round(numberValue, precision))
}

export function parseNumber(value: string) {
  if (value) {
    const unlocalizedValue = value.replace('.', '').replace(',', '.')
    if (unlocalizedValue.includes('.')) {
      return parseFloat(unlocalizedValue)
    } else {
      return parseInt(unlocalizedValue)
    }
  }
  return undefined
}
